import { Component, Mixins } from 'vue-property-decorator';
import { MagicConfigMixin } from '@gig/magic-common';
import { LoyaltyHeader } from '../../../components/loyalty/loyalty-header';
import '../../../components/loyalty-tier-card';
import '../../../components/loyalty-tier-container'

@Component({
    components: {
        'loyalty-header': LoyaltyHeader,
    },
})
export default class LoyaltyOverviewPage extends Mixins(MagicConfigMixin) {}
